<template>
    <div class="homeType">
        <div :style="`margin-top:${top}rem;margin-bottom:${bottom}rem;`" class="title">{{$t(text).toUpperCase()}}</div>
    </div>
</template>
<script>
export default {
    props:{
        text:{
            default:'设置标题名称'
        },
        top:{
            default:2
        },
        bottom:{
            default:2
        },
    }
}
</script>
<style lang="less" scoped>
.homeType{
    .title{
        margin: 0 auto;
        display: block;
        width: fit-content;
        font-size: 1.5rem;
        font-weight: bold;
        color: #3F3F3F;
        font-family: 'YHBD';
    }
}
</style>
<i18n>
{
  "en": {
      "誉诚防护": "Yucheng Protection",
       "热门产品":"Hot Products",
       "誉诚数据": "Yucheng Data",
       "誉诚产品": "Yucheng Products",
       "快速链接": "Quick Link",
       "我们的工厂": "Our Factory",
       "新闻中心": "News Center"
  },
  "zh": {
      "誉诚防护":"誉诚防护",
      "热门产品":"热门产品",
      "誉诚数据":"誉诚数据",
      "誉诚产品":"誉诚产品",
      "快速链接":"快速链接",
      "我们的工厂":"我们的工厂",
      "新闻中心":"新闻中心"
    }
}
</i18n>
